module.exports = __webpack_public_path__ + "img/d5e098c.png";